import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./status-indicator.module.scss";
import ConnectionStatus from "../data/connection-status";
import { mapConnectionStatus } from "../helper/language-helper";
import HoverTooltip from "./hover-tooltip";
import { classArr } from "../helper/style-helper";
import whitelabel from "../whitelabel";

const STATUS_COLORS = Object.freeze<{ [key in ConnectionStatus]: string }>({
	active: whitelabel.palette.active500,
	inactive: whitelabel.palette.error900,
	unpaired: whitelabel.palette.secondary300,
	registered: whitelabel.palette.warning900,
});

//A simple active / inactive / unpaired status indicator component
export default function StatusIndicator(props: {
	style?: CSSProperties;
	className?: string;
	status: ConnectionStatus;
}) {
	const { t } = useTranslation();
	const color = STATUS_COLORS[props.status];

	return (
		<HoverTooltip
			style={props.style}
			wrapperClassName={classArr(props.className, styles.container)}
			tooltip={mapConnectionStatus(props.status, t)}
		>
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				width={16}
				height={16}
				viewBox={"0 0 16 16"}
			>
				<circle cx="8" cy="8" r={6} fill={color} opacity="0.6" />
				<circle cx="8" cy="8" r={4} fill={color} />
			</svg>
		</HoverTooltip>
	);
}
